// Footer.js

import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaFacebook, FaGithub, FaInstagram, FaTwitter} from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import FooterLogo from "../assets/Flogo212.png";           // update path if needed
import Founder from "../assets/85532786841.png";       // update path if needed
import "../Styles/Footer.css";

export default function Footer() {
  return (
    <footer className="frisque-footer">
      <Container>
        {/* TOP: grid with left / center / right */}
        <div className="frisque-top" role="region" aria-label="Footer top">
          {/* LEFT */}
          <div className="frisque-left">
            <div className="frisque-socials" aria-hidden="false">
              <a className="frisque-social github" href="https://www.facebook.com/paramountgreenservices/" target="_blank" rel="noreferrer" aria-label="GitHub">
                <FaFacebook />
              </a>
              <a className="frisque-social linkedin" href="https://www.instagram.com/paramountgreenservices/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
                <FaInstagram />
              </a>
              <a className="frisque-social youtube" href="https://x.com/PGS_PK" target="_blank" rel="noreferrer" aria-label="YouTube">
                <FaTwitter />
              </a>
              <a className="frisque-social email" href="mailto:paramountgreenservice@gmail.com" aria-label="Email">
                <MdEmail />
              </a>
            </div>

            <button className="frisque-cta" type="button" aria-label="Start conversation">
              <Link to="/Contactus/" style={{textDecoration:"none",color:"white"}}>Let’s start a conversation!</Link>
            </button>
          </div>

          {/* CENTER */}
          <div className="frisque-center">
            <a href="/" className="frisque-logo-link"><img src={FooterLogo} alt="Company logo" className="frisque-logo" /></a>

            <nav className="frisque-nav" aria-label="Footer navigation">
              <Link to="/about-us/" className="frisque-navlink">ABOUT</Link>
              <Link to="/services/" className="frisque-navlink">SERVICES</Link>
              <Link to="/careers/" className="frisque-navlink">Careers</Link>
              <Link to="/Why-Choose-Us/" className="frisque-navlink">Why Choose Us</Link>
            </nav>
          </div>

          {/* RIGHT (founder/contact) */}
          <div className="frisque-right">
            <div className="frisque-founder">
              <img src={Founder} alt="Founder" className="frisque-founder-img" />
              <div className="frisque-founder-text">
                <div className="muted small">Founder &amp; Creative Director</div>
                <div className="name">Muhammad Asghar Ali Rana</div>
                <div className="muted small phone"><a href="tel:+923068629918" className="phone" style={{textDecoration:"none"}}>(+92) 306-8629918</a></div>
                <div className="muted small mail"><a href="mailto:paramountgreenservice@gmail.com" className="mail" style={{textDecoration:"none"}}>paramountgreenservice@gmail.com</a></div>
              </div>
            </div>
          </div>
        </div>

        <hr className="frisque-divider" />

        {/* BOTTOM */}
        <div className="frisque-bottom">
          <div className="frisque-copyright">
            © {new Date().getFullYear()} Paramount Green Service Pvt Ltd. All Rights Reserved
          </div>
          <div className="frisque-policies">
            <Link to="/PrivacyPolicy" className="frisque-policy">Privacy Policy</Link>
            <span className="pipe">|</span>
            <Link to="/terms" className="frisque-policy">Terms &amp; Conditions</Link>
          </div>
        </div>
      </Container>
    </footer>
  );
}


